import { render, staticRenderFns } from "./DeliveryNotification.vue?vue&type=template&id=03896b6a&scoped=true&"
import script from "./DeliveryNotification.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotification.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNotification.vue?vue&type=style&index=0&id=03896b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03896b6a",
  null
  
)

export default component.exports